import React from 'react'
import logo from './logo.svg'
import { Router, Route, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'
import Index from './pages/index/index'
import ProductIntroduction  from './pages/index/product_intro'
import Colleges from './pages/index/colleges'
import ProjectList from './pages/project/project-list'
import TaskLearn from './pages/task/task-learn'
import ProjectMain from './pages/project/project-main'
import ProjectMainStudent from './pages/project/project-main-student'
import OAMUserStat from './pages/oam/user/oam-user-stat'
import OAMUserAnalysis from './pages/oam/user/oam-user-analysis'
import OAMMenuList from './pages/oam/menu/oam-menu-list'
import OAMMenuEdit from './pages/oam/menu/oam-menu-edit'
import OAMMenuDetail from './pages/oam/menu/oam-menu-detail'
import OAMVideoList from './pages/oam/video/oam-video-list'
import OAMChapterList from './pages/oam/chapter/oam-chapter-list'
import OAMChapterDetail from './pages/oam/chapter/oam-chapter-detail'
import OAMChapterEdit from './pages/oam/chapter/oam-chapter-edit'
import OAMChapterCreate from './pages/oam/chapter/oam-chapter-create'
import OAMUserList from './pages/oam/user/oam-user-list'
import OAMMenuCreate from './pages/oam/menu/oam-menu-create'
import OAMTaskList from './pages/oam/task/oam-task-list'
import OAMTaskEdit from './pages/oam/task/oam-task-edit'
import OAMTaskPreview from './pages/oam/task/oam-task-preview'
import OAMExerciseList from './pages/oam/exercise/oam-exercise-list'
import OAMExerciseEdit from './pages/oam/exercise/oam-exercise-edit'
import OAMExercisePreview from './pages/oam/exercise/oam-exercise-preview'
import OAMProjectList from './pages/oam/project/oam-project-list'
import OAMProjectDetail from './pages/oam/project/oam-project-detail'
import OAMProjectEdit from './pages/oam/project/oam-project-edit'
import OAMProjectCreate from './pages/oam/project/oam-project-create'
import UserCenter from './pages/common/user-center/user-center'
import OAMTeacherApplyList from './pages/oam/user/oam-teacher-apply-list'
import OAMCollegeCodeApplyList from './pages/oam/user/oam-college-code-apply-list'
import OAMInstitutionList from './pages/oam/institution/oam-institution-list'
import OAMInstitutionEdit from './pages/oam/institution/oam-institution-edit'
import OAMInstitutionUserManager from './pages/oam/institution/oam-institution-user-manage'
// import CollegeOAM from './pages/college-oam/college-oam';
import OAMInstitutionPreview from './pages/oam/institution/oam-institution-preview'
import OAMClassRoomList from './pages/oam/classroom/oam-classroom-list'
import OAMClassRoomEdit from './pages/oam/classroom/oam-classroom-edit'
import OAMClassRoomDetail from './pages/oam/classroom/oam-classroom-detail'
import OAMReportNodeList from './pages/oam/report-node/oam-report-node-list'
import OAMReportNodePreview from './pages/oam/report-node/oam-report-node-preview'
import OAMReportNodeEdit from './pages/oam/report-node/oam-report-node-edit'
import OAMReportList from './pages/oam/report/oam-report-list'
import OAMReportEdit from './pages/oam/report/oam-report-edit'
import OAMReportPreview from './pages/oam/report/oam-report-preview'
import OAMClusterManager from './pages/oam/cluster/index'
import OAMClusterDetail from './pages/oam/cluster/cluster-detail'
import OAMCommitRecord from './pages/oam/commit/index'
import OAMCommitDetail from './pages/oam/commit/commit-detail/commit-detail'
import MyReportPreview from './pages/project/my-report-preview'
import UserReportPreview from './pages/project/user-report-preview'
import CollegeAdmin from './pages/college-oam'
import CommitDetail from './pages/oam/components/commit-detail/CommitDetail'
import OAMLogoManageList from './pages/oam/logo/logo-manage-list'
import OAMLogoManageForm from './pages/oam/logo/logo-manage-form'
import FullReportPreview from './pages/project/full-report-preview'
import LoginRecords from './pages/login-records'
import OAMDatasetList from './pages/oam/dataset'
import DatasetDetailPage from './pages/oam/dataset/detail/DatasetDetail'
import OAMImageList from './pages/oam/image/oam-image-list'
import OAMImagePreview from './pages/oam/image/oam-image-preview'

import ProjectDetail from './pages/project/project-detail'
import OAMCategoryList from './pages/oam/project/oam-project-category-list'
import OAMPaymentOrderList from './pages/oam/payment/oam-payment-order-list'
import PageHeader from './pages/common/page-header/header'


function App() {
  return (
    <div className="App">
      <div className={'router'}>
        <Switch>
          <Route path={['/', '/key_features', '/colleges', '/projects']} exact>
            <PageHeader keys={[]} />
            <Switch>
              <Route path={'/'} exact component={Index} />
              <Route path={'/key_features'} exact component={ProductIntroduction} />
              <Route path={'/colleges'} exact component={Colleges} />
              <Route path={'/projects'} exact component={ProjectList} />
            </Switch>
          </Route>

          <Route path={'/college_login_records'} exact component={LoginRecords} />
          <Route path={'/oam_user_list'} exact component={OAMUserList} />
          <Route path={'/oam_user_stat'} exact component={OAMUserStat} />
          <Route path={'/oam_user_analysis'} exact component={OAMUserAnalysis} />
          <Route path={'/oam_dataset_list'} exact component={OAMDatasetList} />
          <Route path={'/oam_dataset_detail/:id'} exact component={DatasetDetailPage} />

          <Route
            path={'/oam_teacher_apply'}
            exact
            component={OAMTeacherApplyList}
          />
          <Route
            path={'/oam_college_code_apply'}
            exact
            component={OAMCollegeCodeApplyList}
          />

          <Route path={'/project_main'} exact component={ProjectMain} />
          <Route path={'/project_detail'} exact component={ProjectDetail} />

          <Route
            path={'/project_main_student'}
            exact
            component={ProjectMainStudent}
          />
          <Route path={'/report_preview_my'} exact component={MyReportPreview} />
          <Route
            path={'/user_report_preview'}
            exact
            component={UserReportPreview}
          />
          <Route
            path={'/full_report_preview'}
            exact
            component={FullReportPreview}
          />

          <Route path={'/task_learn'} exact component={TaskLearn} />

          <Route path={'/user-center'} exact component={UserCenter} />

          <Route path={'/oam_project'} exact component={OAMProjectList} />
          <Route path={'/oam_purchase_list'} exact component={OAMPaymentOrderList} />
          <Route
            path={'/oam_project_detail'}
            exact
            component={OAMProjectDetail}
          />

          <Route
            path={'/oam_category_list'}
            exact
            component={OAMCategoryList}
          />
          <Route path={'/oam_project_edit'} exact component={OAMProjectEdit} />
          <Route
            path={'/oam_project_create'}
            exact
            component={OAMProjectCreate}
          />

          <Route path={'/oam'} exact component={OAMUserStat} />
          <Route path={'/oam_menu'} exact component={OAMMenuList} />
          <Route path={'/oam_menu_detail'} exact component={OAMMenuDetail} />
          <Route path={'/oam_menu_edit'} exact component={OAMMenuEdit} />
          <Route path={'/oam_menu_create'} exact component={OAMMenuCreate} />

          <Route path={'/oam_video'} exact component={OAMVideoList} />

          <Route path={'/oam_chapter'} exact component={OAMChapterList} />
          <Route
            path={'/oam_chapter_detail'}
            exact
            component={OAMChapterDetail}
          />
          <Route path={'/oam_chapter_edit'} exact component={OAMChapterEdit} />
          <Route
            path={'/oam_chapter_create'}
            exact
            component={OAMChapterCreate}
          />

          <Route path={'/oam_image'} exact component={OAMImageList} />
          <Route
            path={'/oam_image_preview'}
            exact
            component={OAMImagePreview}
          />

          <Route path={'/oam_task'} exact component={OAMTaskList} />
          <Route path={'/oam_task_edit'} exact component={OAMTaskEdit} />
          <Route path={'/oam_task_create'} exact component={OAMTaskEdit} />
          <Route path={'/oam_preview_task'} exact component={OAMTaskPreview} />

          <Route path={'/oam_exercise'} exact component={OAMExerciseList} />
          <Route path={'/oam_exercise_edit'} exact component={OAMExerciseEdit} />
          <Route
            path={'/oam_exercise_preview'}
            exact
            component={OAMExercisePreview}
          />

          <Route
            path={'/oam_institution_list'}
            exact
            component={OAMInstitutionList}
          />
          <Route
            path={'/oam_institution_edit'}
            exact
            component={OAMInstitutionEdit}
          />
          <Route
            path={'/oam_preview_institution'}
            exact
            component={OAMInstitutionPreview}
          />
          <Route
            path={'/oam_institution_user_manager'}
            exact
            component={OAMInstitutionUserManager}
          />

          <Route path={'/oam_classroom'} exact component={OAMClassRoomList} />
          <Route
            path={'/oam_classroom_detail'}
            exact
            component={OAMClassRoomDetail}
          />
          <Route
            path={'/oam_classroom_edit'}
            exact
            component={OAMClassRoomEdit}
          />

          <Route path={'/oam_report_node'} exact component={OAMReportNodeList} />
          <Route
            path={'/oam_report_node_edit'}
            exact
            component={OAMReportNodeEdit}
          />
          <Route
            path={'/oam_report_node_preview'}
            exact
            component={OAMReportNodePreview}
          />

          <Route path={'/oam_report'} exact component={OAMReportList} />
          <Route path={'/oam_report_edit'} exact component={OAMReportEdit} />
          <Route
            path={'/oam_report_preview'}
            exact
            component={OAMReportPreview}
          />

          <Route path={'/oam_logo_manager'} exact component={OAMLogoManageList} />
          <Route path={'/oam_logo_create'} exact component={OAMLogoManageForm} />
          <Route
            path={'/oam_logo_edit/:logoId'}
            exact
            component={OAMLogoManageForm}
          />

          <Route path={'/college-oam'} component={CollegeAdmin} />

          <Route
            path={'/oam_cluster_manager'}
            exact
            component={OAMClusterManager}
          />
          <Route
            path={'/oam_cluster_detail'}
            exact
            component={OAMClusterDetail}
          />

          <Route path={'/oam_commit_record'} exact component={OAMCommitRecord} />
          <Route path={'/oam_commit_detail'} exact component={OAMCommitDetail} />
        </Switch>
      </div>
    </div>
  )
}

export default App
